module.exports = __webpack_public_path__ + "img/logo.c9620959.svg";